module.exports = __webpack_public_path__ + "img/ic_band_right_select.e8f40165.png";